namespace GeniuzPOS.ReportMasterData {
    export interface ReprintReceiptData extends Serenity.ListRequest {
        Header?: Report_1201Row;
        Recv?: Report_1201_RecvRow[];
        Disc?: Report_1201_DiscRow[];
        Detail?: Report_1201_DtRow[];
        DocNo?: string;
        Type?: number;
        times?: string;
        URLpic?: string;
        TaxId?: string;
        PosPermitNo?: string;
        ShopLogoOnReceipt?: string;
        RecptHeadMesg1?: string;
        RecptHeadMesg2?: string;
        RecptHeadMesg3?: string;
        RecptHeadMesg4?: string;
        RecptHeadMesg5?: string;
        RecptHeadMesg6?: string;
        RecptFootMesg1?: string;
        RecptFootMesg2?: string;
        RecptFootMesg3?: string;
        RecptFootMesg4?: string;
        RecptFootMesg5?: string;
        RecptFootMesg6?: string;
        RecptFootMesg7?: string;
        RecptFootMesg8?: string;
        RecptFootMesg9?: string;
        RecptFootMesg10?: string;
    }
}
